import { z } from "zod";

export const TOPICS = [
  "General inquiry",
  "Partnerships",
  "Press and media",
  "Technical support",
  "Careers",
  "Something else",
] as const;

export const ContactValues = z.object({
  firstName: z.string().min(1, "Enter your first name"),
  lastName: z.string().min(1, "Enter your last name"),
  email: z.email("Enter a valid email address"),
  phone: z.string(),
  topics: z.array(z.string()).min(1, "Choose at least one"),
  message: z.string().min(1, "Tell us what you need"),
});

export type ContactValues = z.infer<typeof ContactValues>;
